<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form">
        <div class="brief-form">
          <div
            class="
              form__input-wrapper
              form__input-wrapper--check
              form__input-wrapper--check-squer
            "
            v-for="radio in formRadios"
            :key="radio.name"
          >
            <input
              class=""
              :id="radio.name"
              type="checkbox"
              name="findOutAboutUs"
              :value="radio.value"
              v-model.trim="form.findOutAboutUs"
              @input="invokeTouch($v.form.findOutAboutUs)"
            />
            <label :for="radio.name" class="form__label">
              {{ radio.label }}
              <Tooltip v-if="radio.tooltip" :title="radio.tooltip" />
            </label>
          </div>
        </div>
        <div
          class="
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
        >
          <input
            class=""
            id="foas-website"
            type="checkbox"
            name="foas-website"
            value="dzięki innej wykonanej przez Was stronie"
            @input="invokeTouch($v.form.findOutAboutUs)"
            @click="websiteHandler"
          />
          <label for="foas-website" class="form__label">
            dzięki innej wykonanej przez Was stronie
          </label>
        </div>
        <transition name="fade-input">
          <div
            v-if="hasWebsite"
            class="form__input-wrapper"
            :class="{ error: $v.form.findOutAboutUsWebsite.$anyError }"
          >
            <label for="findOutAboutUsWebsite" class="form__label"
              >podaj proszę jej adres, to dla nas cenny feedback:</label
            >
            <input
              class="form-input uk-width-1-1"
              id="findOutAboutUsWebsite"
              type="text"
              name="findOutAboutUsWebsite"
              ref="websiteInput"
              @input="event => delayTouchCounterComposition($v.form, 'findOutAboutUsWebsite', event.target.value)"
            />
            <span class="form__error-message">
              <template v-if="!$v.form.findOutAboutUsWebsite.minLength">
                {{ validationMessage.minLength }}</template
              >
              <template v-if="!$v.form.findOutAboutUsWebsite.required">
                {{ validationMessage.required }}</template
              >
            </span>
          </div>
        </transition>
        <div
          class="
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
        >
          <input
            class=""
            id="foas-recommendations"
            type="checkbox"
            name="foas-recommendations"
            value="z polecenia"
            @input="invokeTouch($v.form.findOutAboutUs)"
            @click="recommendationHandler"
          />
          <label for="foas-recommendations" class="form__label">z polecenia</label>
        </div>
        <transition name="fade-input">
          <div
            v-if="hasRecommendation"
            class="form__input-wrapper"
            :class="{ error: $v.form.findOutAboutUsRecommendation.$anyError }"
          >
            <label for="findOutAboutUsRecommendation" class="form__label"
              >Kto nas polecił? Chcielibyśmy mu podziękować:</label
            >
            <input
              class="form-input uk-width-1-1"
              id="findOutAboutUsRecommendation"
              type="text"
              name="findOutAboutUsRecommendation"
              ref="recommendationInput"
              @input="event => delayTouchCounterComposition($v.form, 'findOutAboutUsRecommendation', event.target.value)"
            />
            <span class="form__error-message">
              <template v-if="!$v.form.findOutAboutUsRecommendation.minLength">
                {{ validationMessage.minLength }}</template
              >
              <template v-if="!$v.form.findOutAboutUsRecommendation.required">
                {{ validationMessage.required }}</template
              >
            </span>
          </div>
        </transition>

        <div
          class="
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
        >
          <input
            class=""
            id="foas-other"
            type="checkbox"
            name="foas-other"
            value="Inne"
            @input="invokeTouch($v.form.findOutAboutUs)"
            @click="otherHandler"
          />
          <label for="foas-other" class="form__label">Inne</label>
        </div>
        <transition name="fade-input">
          <div
            v-if="hasDescription"
            class="form__input-wrapper"
            :class="{ error: $v.form.findOutAboutUsOther.$anyError }"
          >
            <label for="findOutAboutUsOther" class="form__label uk-hidden"
              >Podaj inne</label
            >
            <input
              class="form-input uk-width-1-1"
              id="findOutAboutUsOther"
              type="text"
              name="findOutAboutUsOther"
              ref="otherInput"
              @input="event => delayTouchCounterComposition($v.form, 'findOutAboutUsOther', event.target.value)"
            />
            <span class="form__error-message form__error-message--no-label">
              <template v-if="!$v.form.findOutAboutUsOther.minLength">
                {{ validationMessage.minLength }}</template
              >
              <template v-if="!$v.form.findOutAboutUsOther.required">
                {{ validationMessage.required }}</template
              >
            </span>
          </div>
        </transition>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';

import BriefStep from '../global/BriefStep.vue';
import Tooltip from '../global/tooltip.vue';

export default {
  name: 'FindOutAboutUs',
  components: { Tooltip, BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      // eslint-disable-next-line operator-linebreak
      'Chodzą słuchy po mieście… No właśnie, jesteśmy bardzo ciekawi, ' +
      'skąd się o nas dowiedziałeś!',
    form: {
      findOutAboutUs: [],
      findOutAboutUsOther: '',
      findOutAboutUsRecommendation: '',
      findOutAboutUsWebsite: '',
    },
    hasWebsite: false,
    hasRecommendation: false,
    hasDescription: false,

    formRadios: [
      {
        name: 'foau-friend',
        value: 'od znajomego',
        label: 'od znajomego',
      },
      {
        name: 'foau-facebook',
        value: 'z Facebooka',
        label: 'z Facebooka',
      },
      {
        name: 'foau-internet',
        value: 'z Internetu',
        label: 'z Internetu',
      },
    ],
  }),
  validations() {
    const result = {
      form: {
        findOutAboutUs: {
          required,
        },
      },
    };
    if (this.hasDescription) {
      result.form.findOutAboutUs = {};
      result.form.findOutAboutUsOther = {
        required,
        minLength: minLength(3),
      };
    }
    if (this.hasRecommendation) {
      result.form.findOutAboutUs = {};
      result.form.findOutAboutUsRecommendation = {
        required,
        minLength: minLength(3),
      };
    }
    if (this.hasWebsite) {
      result.form.findOutAboutUs = {};
      result.form.findOutAboutUsWebsite = {
        required,
        minLength: minLength(3),
      };
    }
    return result;
  },
  methods: {
    otherHandler() {
      this.hasDescription = !this.hasDescription;

      if (!this.hasDescription) {
        this.form.findOutAboutUsOther = '';
      } else {
        setTimeout(() => {
          this.$refs.otherInput.focus();
        }, 100);
      }
    },
    recommendationHandler() {
      this.hasRecommendation = !this.hasRecommendation;

      if (!this.hasRecommendation) {
        this.form.findOutAboutUsRecommendation = '';
      } else {
        setTimeout(() => {
          this.$refs.recommendationInput.focus();
        }, 100);
      }
    },
    websiteHandler() {
      this.hasWebsite = !this.hasWebsite;

      if (!this.hasWebsite) {
        this.form.findOutAboutUsWebsite = '';
      } else {
        setTimeout(() => {
          this.$refs.websiteInput.focus();
        }, 100);
      }
    },
  },
};
</script>
